var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24209 8.75778H3.95659C3.74378 8.75778 3.56419 8.68459 3.41781 8.53822C3.27143 8.39184 3.19824 8.21225 3.19824 7.99945C3.19824 7.78665 3.27143 7.60706 3.41781 7.46068C3.56419 7.3143 3.74378 7.24112 3.95659 7.24112H7.24209V3.95562C7.24209 3.7428 7.31528 3.56321 7.46166 3.41683C7.60804 3.27045 7.78763 3.19727 8.00043 3.19727C8.21323 3.19727 8.39281 3.27045 8.53919 3.41683C8.68557 3.56321 8.75876 3.7428 8.75876 3.95562V7.24112H12.0443C12.2571 7.24112 12.4367 7.3143 12.583 7.46068C12.7294 7.60706 12.8026 7.78665 12.8026 7.99945C12.8026 8.21225 12.7294 8.39184 12.583 8.53822C12.4367 8.68459 12.2571 8.75778 12.0443 8.75778H8.75876V12.0433C8.75876 12.2561 8.68557 12.4357 8.53919 12.5821C8.39281 12.7284 8.21323 12.8016 8.00043 12.8016C7.78763 12.8016 7.60804 12.7284 7.46166 12.5821C7.31528 12.4357 7.24209 12.2561 7.24209 12.0433V8.75778Z",
    fill: "#5534DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.5c01508e816493e294a90c7bbafe82f7.svg";
export { ForwardRef as ReactComponent };